import { render, staticRenderFns } from "./AzSocietiesEdit.vue?vue&type=template&id=898a8d94"
import script from "./AzSocietiesEdit.vue?vue&type=script&lang=js"
export * from "./AzSocietiesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports